import { z } from 'zod';

export const CodeEnforcementAttachmentScalarFieldEnumSchema = z.enum(['attachmentId','cityId','caseId','name','note','location','fileType','fileSize','dateEntered','imageType','archived','version','externalId','rowTimestamp']);

export default CodeEnforcementAttachmentScalarFieldEnumSchema;
